import React from 'react';

import styled, { css } from 'styled-components';

import { Heading } from 'atoms/Typography';

import { LocalizedString } from 'utils/localize';

export interface BannerProps {
  children?: LocalizedString;
}

function Banner({ children }: BannerProps) {
  return (
    <Wrapper>
      <Heading
        level="h2"
        align="center"
        color="white"
        size={1}
        marginBottom={0}
        marginTop={0}
      >
        {children}
      </Heading>
    </Wrapper>
  );
}

export default Banner;

const Wrapper = styled.div`
  padding: calc(1em + 48px) 1em 1em;

  font-size: 32px;

  ${({ theme }) => css`
    background: linear-gradient(
      246deg,
      ${theme.colors.mirage},
      ${theme.colors.oxfordBlue}
    );
  `}

  ${({ theme }) => theme.devices.tablet`
    padding: 2.4em 1em;
    padding-top: 3.4em;
    font-size: 52px;
  `}
`;
